import { FaqSection } from "./FaqSection/FaqSection";
import { HeroSection } from "./HeroSection/HeroSection";
import { LaunchSection } from "./LaunchSection/LaunchSection";
import { LiqiuditySection } from "./LiqiuditySection/LiqiuditySection";
import { RoadmapSection } from "./RoadmapSection/RoadmapSection";
import { getPageTitle } from "../../lib/legacy";
import { t } from "@lingui/macro";
import SEO from "../Common/SEO";
import Footer from "../Footer/Footer";
import "./LandingPage.scss";

export default function Landing() {
  return (
    <SEO title={getPageTitle(t`Landing Page`)}>
      <div className="landingPage page-layout">
        <HeroSection />
        <LaunchSection />
        <LiqiuditySection />
        <FaqSection />
        <RoadmapSection />
        <Footer />
      </div>
    </SEO>
  );
}
